import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class SubCategoryMap extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'SubCategoryMap'
  // Define default properties here
  static instanceDefaults () {
    return {
      fromId: null,
      toId: null,
    }
  }
}
const servicePath = 'sub-categories-map'
const servicePlugin = makeServicePlugin({
  Model: SubCategoryMap,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
